import { useToast, useValidatorSeeker } from "@hooks"
import {
	analyzerDate,
	categories,
	currency,
	includeProviders,
	mainProvider,
	mainSite,
	offices,
	providers,
	reports,
	searchID,
} from "@signals"
import {
	analyzerFilters,
	isAnalyzerLoading,
	resetSignals,
	responseData,
	tableHasMainComparison,
} from "Pages/AnalyzersV2/@signals"
import { lorSchema } from "Pages/AnalyzersV2/Lor/schema"
import {useCallback, useEffect} from "react"
import { batch } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"
import { lorPayload } from "Pages/AnalyzersV2/Lor/@signals"
import { SECTIONS } from "Pages/AnalyzersV2/@constants"


export default function useAnalyzerLorFilters() {
	const { showToast } = useToast()

	const { isValid, errorRegistry } = useValidatorSeeker({
		currency: currency.value,
		officePickupID: offices.value,
		groupBySiteProvider: includeProviders.value,
		dates: analyzerDate.value,
		providerID: providers.value,
		categoryID: categories.value
	}, lorSchema(searchID.value))

	const onSubmit = useCallback((clearTab = false) => batch(() => {
		isAnalyzerLoading.value = true
		responseData.value = {}
		resetSignals(clearTab)
		tableHasMainComparison.value = !!mainSite.value || !!mainProvider.value
		postSubmit("/api/dashboard/results", lorPayload.value).then(res => {
				responseData.value = { ...res, type: SECTIONS.LOR }
				isAnalyzerLoading.value = false
				analyzerFilters.value = res.filters
		}).catch(() => {
			showToast.error()
			isAnalyzerLoading.value = false
		})
	}), [isAnalyzerLoading.value])

	return {
		onSubmit: onSubmit,
		isValid: (isValid && !!reports.value) || !!searchID.value,
		errorRegistry: errorRegistry
	}
}